import {Space} from "antd";
import {ServiceCheckoutFormGroups} from "../../accordion/data";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {ServiceCheckoutFormFieldsProps} from "./types";

export function ServiceCheckoutFormFields({
  isBookingQuestionsError,
}: ServiceCheckoutFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {ServiceCheckoutFormGroups.map((fg, index) => {
        if (fg.title === "Checkout form") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isBookingQuestionsError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
